import { Heading, Subtitle } from './PageHeading.styles';
import type { PageHeadingProps } from './PageHeading.types';

export function PageHeading({ title, subtitle, flush }: PageHeadingProps) {
  return (
    <Heading $flush={flush}>
      {title}
      {subtitle && (
        <>
          {' '}
          <Subtitle>{subtitle}</Subtitle>
        </>
      )}
    </Heading>
  );
}
